import { Injectable } from '@angular/core';
import { DatatableHandler } from '../../components/datatables/datatable/datatable/datatable.component';
import {ConfirmModalComponent} from "../../components/modals/confirm-modal/confirm-modal.component";
import {SimpleModalService} from "ngx-simple-modal";
import {ErrorProcessorService} from "../error-processor.service";
import {Router} from "@angular/router";

@Injectable()
export class SimpleNavigationPathDataService {
  navigateToPath: string = '/';
  navigateBackPath: string = '/';
}

export class DataTableDataService {
  dataTable?: DatatableHandler;
}

export class isFormModifiedDataService {
  isFormModified: boolean = false;
}

@Injectable()
export class SimpleNavigationService {
  constructor(private _modalService: SimpleModalService,
              private errorProcessorService: ErrorProcessorService,
              private _router: Router,
              private _isFormModifiedDataService: isFormModifiedDataService,
              ) { }

   public navigateTo(path: string) {

    let isFormModified = this._isFormModifiedDataService.isFormModified;
    if (isFormModified) {
      this._modalService
        .addModal(ConfirmModalComponent, {
          title: 'Biztosan elnavigál az oldalról?',
          message: 'Önnek nem mentett módosításai vannak az oldalon. Biztosan el szeretne navigálni mentés nélkül?',
          confirmText: 'Igen',
          confirmClass: 'btn-primary text-white',
        })
        .subscribe(
          isConfirmed => {
            if (isConfirmed) {
              this._isFormModifiedDataService.isFormModified = false;
              this._router.navigate([path]);
            }
          },
          error => this.errorProcessorService.processError(error)
        );
    } else {
      this._router.navigate([path]);
    }
  }
}

